import { lazy, Suspense } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { Loader } from '@/shared/ui/loader'
import {
  getVisibleLaboratoryTabs,
  LABORATORY_TABS,
} from '@/pages/laboratory/model/tabs'

const LaboratoryPage = lazy(
  () => import('@/pages/laboratory/ui/LaboratoryPage'),
)

const laboratorySearchSchema = z.object({
  tab: z.enum(LABORATORY_TABS).optional(),
})

export const Route = createFileRoute('/_protected/laboratory/')({
  validateSearch: laboratorySearchSchema,
  // Keep the tab in the URL so the sidebar sub-items can highlight the active
  // one, and land on a tab the role may actually open — a read-only role sees
  // the извещения journal but not the analyses queue.
  beforeLoad: ({ search, context }) => {
    const visibleTabs = getVisibleLaboratoryTabs(context.abilityStore.abilities)
    // Nothing to show: let the page render its empty state rather than loop.
    if (visibleTabs.length === 0) return

    const fallbackTab = visibleTabs[0]
    if (!search.tab || !visibleTabs.includes(search.tab)) {
      throw redirect({ to: '/laboratory', search: { tab: fallbackTab } })
    }
  },
  component: () => (
    <Suspense fallback={<Loader />}>
      <LaboratoryPage />
    </Suspense>
  ),
})
